import React, { useEffect, useState, useRef, useLayoutEffect } from 'react';
import './gsap.css';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin.js';

// import TimelineHorizontally from "../timelineHorizontally";
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

function GsapContainer(props) {
  const {
    duration,
    trigger,
    pin,
    children,
    controller,
    animate,
    controls,
    name,
    tween,
    setSection,
    status,
    setCurrentDate,
    anchor
  } = props;

  const comp = useRef();
  const circle = useRef();

  const [progress, setProgress] = useState(0);
  const [initSelf, setInitSelf] = useState();
  const [scrollPos, setScrollPos] = useState(0);
  const [anchors, setAnchors] = useState([]);

  const [end, setEnd] = useState(false);
  const [endOne, setEndOne] = useState(false);
  const [show, setShow] = useState(true);


  const [tw, setTw] = useState(null);
  

  useEffect(() => {
    if (status) {
      console.log('initSelf', initSelf);
      // initSelf.disable();
      // initSelf.enable();
    }
  }, [status]);


  useEffect(() => {
    if (end) {
      ScrollTrigger.killAll();
   
    }
  }, [end]);

  useEffect(() => {
    if (endOne) {
      setShow(false);
      // setSection({"section": "one", status: false})
      ScrollTrigger.killAll();
                  setTimeout(() => {
         
              setSection({"section": "one", status: false})
            }, 300)
   
    }
  }, [endOne]);


  useEffect(() => {
    if (progress) {
      // console.log('progress222', progress);
      // initSelf.disable();
      // initSelf.enable();

      var st = progress;
      // console.log('st: ', st);
      // console.log('scrollPos: ', scrollPos);
      if (st < scrollPos) {
        // down
        // console.log('down');

        if (progress < 0.002) {
          // setTimeout(() => {

          // setEnd(true);
          // setSection({ section: 'tmHz', status: false });
          // }, 400)
        }
      } else {
        // up
        // console.log('up');
      }

      setScrollPos(st);
    }
  }, [progress]);

  let hz = document.querySelector('.timeline-horizontally__container');
  let scrollTween;

  useEffect(() => {
    // let sections = gsap.utils.toArray('.timeline-horizontally__item');

    const width = window.innerWidth;

  //   window.scrollTo({
  //     top: 0,

  // });
    // console.log('width: ', width);

    let ll = document.querySelector('.timeline-horizontally__list').offsetWidth;
    // console.log('document.querySelector(".timeline-horizontally__list"): ', document.querySelector(".timeline-horizontally__list"));
    console.log('ll: ', ll);

    let count = 13.2;



    if (width > 1023 && width < 1441) {
      count = 16.77 + (13.2 - 16.77) * ((width - 1024) / (1440 - 1024));
    } else if (width < 1024) {
      // count = 13.57;
      count = 13.2 + (13.57 - 13.2) * ((width - 768) / (1023 - 768));
    } else if (width > 1440) {
      count = 11.77 + (9.43 - 11.77) * ((width - 1600) / (1960 - 1600));
    }
    console.log('count: ', count);

    setTimeout(() => {
      // console.log("document.querySeloffsetWidth", document.querySelector(".timeline-horizontally__list").offsetWidth);
      // ScrollTrigger.killAll();
      // setSection({"section": 1500"tmHz", status: false})
    }, 5000);

    //   console.log('ll: ', ll);


    if (width > 767) {
      // ll = 21020;
      const num = ll / width;
      // console.log('num: ', num);

       scrollTween = gsap.to('.timeline-horizontally__container', {
        // xPercent: -100 * count, // - длина в процентах горизонтального скролла
        x: () => `-${ll - width}`,
        ease: 'none', // <-- IMPORTANT!
        scrollTrigger: {
          trigger: '.timeline-horizontally',
          pin: true,
          scrub: 1,
          // horizontal:true,
          //snap: directionalSnap(1 / (sections.length - 1)),
          // start: "top 2800",
          end: '+=' + document.querySelector('.timeline-horizontally__list').offsetWidth,
          onEnter: (self) => {
            console.log('enter2');
            const th = document.querySelector('.timeline-horizontally');
            th.classList.add('timeline-horizontally--show');
            // self.trigger.classList.remove("_fadeLeft");
            // self.disable();
            // self.enable();
            setInitSelf(self);
            // self.trigger.classList.add("_active");
          },
          onLeave: (self) => {
            console.log("leave");
            // console.log(".scroll()", self.scroll());
    
            // setTimeout(() => {
              // self.kill()
              // setSection({"section": "one", status: false})
            // }, 800)
          },    
          onLeaveBack: (self) => {
            console.log('onLeaveBackTM');
          },
          onUpdate: (self) => setProgress(self.progress),
        },
      });

      // ScrollTrigger.disable();
      // setTimeout(() => {
      //   console.log("1111");
      //   // console.log('scrollTween.scroll: ', scrollTween.scroll());
      //   // console.log('scrollTween.scroll: ',
      //   // console.log('scrollTween.scroll: ', ScrollTrigger.clearScrollMemory());
      //   // console.log('scrollTween.scroll: ', ScrollTrigger.enable());
      //   // scrollTween.scroll(100);
      // scrollTween.disable();

      //  },5000)

      ScrollTrigger.create({
        trigger: '.timeline-horizontally__col--6-1 .timeline-horizontally__month',
        containerAnimation: scrollTween,
        start: 'left 75%',
        // end: "right 10%",
        onEnter: (self) => {
          console.log('enter', self);
          // self.trigger.classList.remove("_fadeLeft");

          self.trigger.classList.add('_active');
        },
        // onLeave: (self) => {
        //   console.log("leave");
        //   self.trigger.classList.add("_hide");
        //   self.trigger.classList.remove("_active");
        // },
        // onEnterBack: (self) => {
        //   console.log("onEnterBack", self);
        //   self.trigger.classList.add("_active");
        //   self.trigger.classList.remove("_hide");
        // },
        // onLeaveBack: (self) => {
        //   console.log("onLeaveBack");
        //   self.trigger.classList.remove("_active");
        // },
        // onToggle: (self) => console.log("active", self.isActive),
      });

      ScrollTrigger.create({
        trigger: '.timeline-horizontally__col--6-2 .timeline-horizontally__title',
        containerAnimation: scrollTween,
        start: 'left 95%',
        end: 'right 40%',
        onEnter: (self) => {
          // console.log("enter", self);
          // self.trigger.classList.remove("_fadeLeft");
          self.trigger.classList.add('_active');
        },
        // onLeave: (self) => {
        //   // console.log("leave");
        //   self.trigger.classList.add("_hide");
        //   self.trigger.classList.remove("_active");
        // },
        // onEnterBack: (self) => {
        //   // console.log("onEnterBack", self);
        //   self.trigger.classList.add("_active");
        //   self.trigger.classList.remove("_hide");
        // },
        // onLeaveBack: (self) => {
        //   // console.log("onLeaveBack");
        //   self.trigger.classList.remove("_active");
        // },
      });

      ScrollTrigger.create({
        trigger: '.timeline-horizontally__col--6-3 .timeline-horizontally__img',
        containerAnimation: scrollTween,
        start: 'left 95%',
        end: 'right 20%',
        onEnter: (self) => {
          // console.log("enter", self);
          // self.trigger.classList.remove("_fadeLeft");
          self.trigger.classList.add('_active');
        },
        // onLeave: (self) => {
        //   // console.log("leave");
        //   self.trigger.classList.add("_hide");
        //   self.trigger.classList.remove("_active");
        // },
        // onEnterBack: (self) => {
        //   // console.log("onEnterBack", self);
        //   self.trigger.classList.add("_active");
        //   self.trigger.classList.remove("_hide");
        // },
        // onLeaveBack: (self) => {
        //   // console.log("onLeaveBack");
        //   self.trigger.classList.remove("_active");
        // },
        // onToggle: (self) => console.log("active", self.isActive),
      });

      ScrollTrigger.create({
        trigger: '.timeline-horizontally__col--6-3 .note',
        containerAnimation: scrollTween,
        start: 'left 95%',
        end: 'right 50%',
        onEnter: (self) => {
          // console.log("enter", self);
          // self.trigger.classList.remove("_fadeLeft");
          self.trigger.classList.add('_active');
        },
        // onLeave: (self) => {
        //   // console.log("leave");
        //   self.trigger.classList.add("_hide");
        //   self.trigger.classList.remove("_active");
        // },
        // onEnterBack: (self) => {
        //   // console.log("onEnterBack", self);
        //   self.trigger.classList.add("_active");
        //   self.trigger.classList.remove("_hide");
        // },
        // onLeaveBack: (self) => {
        //   // console.log("onLeaveBack");
        //   self.trigger.classList.remove("_active");
        // },
        // onToggle: (self) => console.log("active", self.isActive),
      });

      ScrollTrigger.create({
        trigger: '.timeline-horizontally__col--6-4 .timeline-horizontally__text--1',
        containerAnimation: scrollTween,
        start: 'left 95%',
        end: 'right 40%',
        onEnter: (self) => {
          self.trigger.classList.add('_active');
        },
        // onLeave: (self) => {
        //   self.trigger.classList.add("_hide");
        //   self.trigger.classList.remove("_active");
        // },
        // onEnterBack: (self) => {
        //   self.trigger.classList.add("_active");
        //   self.trigger.classList.remove("_hide");
        // },
        // onLeaveBack: (self) => {
        //   self.trigger.classList.remove("_active");
        // },
      });

      ScrollTrigger.create({
        trigger: '.timeline-horizontally__col--6-4 .timeline-horizontally__text--2',
        containerAnimation: scrollTween,
        start: 'left 95%',
        end: 'right 30%',
        onEnter: (self) => {
          self.trigger.classList.add('_active');
        },
        // onLeave: (self) => {
        //   self.trigger.classList.add("_hide");
        //   self.trigger.classList.remove("_active");
        // },
        // onEnterBack: (self) => {
        //   self.trigger.classList.add("_active");
        //   self.trigger.classList.remove("_hide");
        // },
        // onLeaveBack: (self) => {
        //   self.trigger.classList.remove("_active");
        // },
      });

      ScrollTrigger.create({
        trigger: '.timeline-horizontally__col--6-5 .timeline-horizontally__img--1',
        containerAnimation: scrollTween,
        start: 'left 95%',
        end: 'right 20%',
        onEnter: (self) => {
          // console.log("enter", self);
          // self.trigger.classList.remove("_fadeLeft");
          self.trigger.classList.add('_active');
        },
        // onLeave: (self) => {
        //   // console.log("leave");
        //   self.trigger.classList.add("_hide");
        //   self.trigger.classList.remove("_active");
        // },
        // onEnterBack: (self) => {
        //   // console.log("onEnterBack", self);
        //   self.trigger.classList.add("_active");
        //   self.trigger.classList.remove("_hide");
        // },
        // onLeaveBack: (self) => {
        //   // console.log("onLeaveBack");
        //   self.trigger.classList.remove("_active");
        // },
        // onToggle: (self) => console.log("active", self.isActive),
      });

      ScrollTrigger.create({
        trigger: '.timeline-horizontally__col--6-5 .timeline-horizontally__img--2',
        containerAnimation: scrollTween,
        start: 'left 95%',
        end: 'right 20%',
        onEnter: (self) => {
          self.trigger.classList.add('_active');
        },
        // onLeave: (self) => {
        //   self.trigger.classList.add("_hide");
        //   self.trigger.classList.remove("_active");
        // },
        // onEnterBack: (self) => {
        //   self.trigger.classList.add("_active");
        //   self.trigger.classList.remove("_hide");
        // },
        // onLeaveBack: (self) => {
        //   self.trigger.classList.remove("_active");
        // },
      });

      ScrollTrigger.create({
        trigger: '.timeline-horizontally__col--6-6 .note',
        containerAnimation: scrollTween,
        start: 'left 95%',
        end: 'right 30%',
        onEnter: (self) => {
          self.trigger.classList.add('_active');
        },
        // onLeave: (self) => {
        //   self.trigger.classList.add("_hide");
        //   self.trigger.classList.remove("_active");
        // },
        // onEnterBack: (self) => {
        //   self.trigger.classList.add("_active");
        //   self.trigger.classList.remove("_hide");
        // },
        // onLeaveBack: (self) => {
        //   self.trigger.classList.remove("_active");
        // },
      });

      ScrollTrigger.create({
        trigger: '.timeline-horizontally__col--6-6 .timeline-horizontally__text',
        containerAnimation: scrollTween,
        start: 'left 95%',
        end: 'right 30%',
        onEnter: (self) => {
          self.trigger.classList.add('_active');
        },
        // onLeave: (self) => {
        //   self.trigger.classList.add("_hide");
        //   self.trigger.classList.remove("_active");
        // },
        // onEnterBack: (self) => {
        //   self.trigger.classList.add("_active");
        //   self.trigger.classList.remove("_hide");
        // },
        // onLeaveBack: (self) => {
        //   self.trigger.classList.remove("_active");
        // },
      });

      ScrollTrigger.create({
        trigger: '.timeline-horizontally__col--9-1 .timeline-horizontally__month',
        containerAnimation: scrollTween,
        start: 'left 100%',
        end: 'right 30%',
        onEnter: (self) => {
          self.trigger.classList.add('_active');
          // setCurrentFooter(2);
        },
        // onLeave: (self) => {
        //   self.trigger.classList.add("_hide");
        //   self.trigger.classList.remove("_active");
        // },
        onEnterBack: (self) => {
          // self.trigger.classList.add("_active");
          // self.trigger.classList.remove("_hide");
          // setCurrentFooter(1);
          // console.log('no');
        },
        onLeaveBack: (self) => {
          //   self.trigger.classList.remove("_active");
          // setCurrentFooter(1);
          // console.log('no2');
        },
      });

      ScrollTrigger.create({
        trigger: '.timeline-horizontally__col--9-2 .timeline-horizontally__title',
        containerAnimation: scrollTween,
        start: 'left 90%',
        end: 'right 50%',
        onEnter: (self) => {
          self.trigger.classList.add('_active');
          setCurrentFooter(2);
        },
        // onLeave: (self) => {
        //   self.trigger.classList.add("_hide");
        //   self.trigger.classList.remove("_active");
        // },
        onEnterBack: (self) => {
          // self.trigger.classList.add("_active");
          // self.trigger.classList.remove("_hide");
          setCurrentFooter(1);
          console.log('no');
        },
        onLeaveBack: (self) => {
          //   self.trigger.classList.remove("_active");
          setCurrentFooter(1);
          console.log('no2');
        },
      });

      ScrollTrigger.create({
        trigger: '.timeline-horizontally__col--9-3 .timeline-horizontally__text',
        containerAnimation: scrollTween,
        start: 'left 95%',
        end: 'right 30%',
        onEnter: (self) => {
          self.trigger.classList.add('_active');
        },
        // onLeave: (self) => {
        //   self.trigger.classList.add("_hide");
        //   self.trigger.classList.remove("_active");
        // },
        // onEnterBack: (self) => {
        //   self.trigger.classList.add("_active");
        //   self.trigger.classList.remove("_hide");
        // },
        // onLeaveBack: (self) => {
        //   self.trigger.classList.remove("_active");
        // },
      });

      ScrollTrigger.create({
        trigger: '.timeline-horizontally__col--9-4 .timeline-horizontally__img',
        containerAnimation: scrollTween,
        start: 'left 95%',
        end: 'right 30%',
        onEnter: (self) => {
          self.trigger.classList.add('_active');
          // setCurrentFooter(3);
        },
        // onLeave: (self) => {
        //   self.trigger.classList.add("_hide");
        //   self.trigger.classList.remove("_active");
        // },
        // onEnterBack: (self) => {
        //   self.trigger.classList.add("_active");
        //   self.trigger.classList.remove("_hide");
        // },
        onLeaveBack: (self) => {
          // setCurrentFooter(2);
        },
      });

      ScrollTrigger.create({
        trigger: '.timeline-horizontally__col--6-1-1 .timeline-horizontally__month',
        containerAnimation: scrollTween,
        start: 'left 95%',
        end: 'right 30%',
        onEnter: (self) => {
          self.trigger.classList.add('_active');
          // setCurrentFooter(2);
        },
        // onLeave: (self) => {
        //   self.trigger.classList.add("_hide");
        //   self.trigger.classList.remove("_active");
        // },
        onEnterBack: (self) => {
          // self.trigger.classList.add("_active");
          // self.trigger.classList.remove("_hide");
          // setCurrentFooter(1);
          // console.log('no');
        },
        onLeaveBack: (self) => {
          //   self.trigger.classList.remove("_active");
          // setCurrentFooter(1);
          // console.log('no2');
        },
      });

      ScrollTrigger.create({
        trigger: '.timeline-horizontally__col--6-1-2 .timeline-horizontally__title',
        containerAnimation: scrollTween,
        start: 'left 95%',
        end: 'right 30%',
        onEnter: (self) => {
          self.trigger.classList.add('_active');
          setCurrentFooter(3);
        },
        // onLeave: (self) => {
        //   self.trigger.classList.add("_hide");
        //   self.trigger.classList.remove("_active");
        // },
        // onEnterBack: (self) => {
        //   self.trigger.classList.add("_active");
        //   self.trigger.classList.remove("_hide");
        // },
        onLeaveBack: (self) => {
          setCurrentFooter(2);
        },
      });

      ScrollTrigger.create({
        trigger: '.timeline-horizontally__col--6-1-3 .timeline-horizontally__text',
        containerAnimation: scrollTween,
        start: 'left 95%',
        end: 'right 30%',
        onEnter: (self) => {
          self.trigger.classList.add('_active');
        },
        // onLeave: (self) => {
        //   self.trigger.classList.add("_hide");
        //   self.trigger.classList.remove("_active");
        // },
        // onEnterBack: (self) => {
        //   self.trigger.classList.add("_active");
        //   self.trigger.classList.remove("_hide");
        // },
        // onLeaveBack: (self) => {
        //   self.trigger.classList.remove("_active");
        // },
      });

      ScrollTrigger.create({
        trigger: '.timeline-horizontally__col--6-1-3 .timeline-horizontally__quote',
        containerAnimation: scrollTween,
        start: 'left 95%',
        end: 'right 30%',
        onEnter: (self) => {
          self.trigger.classList.add('_active');
        },
        // onLeave: (self) => {
        //   self.trigger.classList.add("_hide");
        //   self.trigger.classList.remove("_active");
        // },
        // onEnterBack: (self) => {
        //   self.trigger.classList.add("_active");
        //   self.trigger.classList.remove("_hide");
        // },
        // onLeaveBack: (self) => {
        //   self.trigger.classList.remove("_active");
        // },
      });

      ScrollTrigger.create({
        trigger: '.timeline-horizontally__col--6-1-4 .note',
        containerAnimation: scrollTween,
        start: 'left 95%',
        end: 'right 30%',
        onEnter: (self) => {
          self.trigger.classList.add('_active');
        },
        // onLeave: (self) => {
        //   self.trigger.classList.add("_hide");
        //   self.trigger.classList.remove("_active");
        // },
        // onEnterBack: (self) => {
        //   self.trigger.classList.add("_active");
        //   self.trigger.classList.remove("_hide");
        // },
        // onLeaveBack: (self) => {
        //   self.trigger.classList.remove("_active");
        // },
      });

      ScrollTrigger.create({
        trigger: '.timeline-horizontally__col--6-1-5 .timeline-horizontally__quote',
        containerAnimation: scrollTween,
        start: 'left 100%',
        end: 'right 30%',
        onEnter: (self) => {
          self.trigger.classList.add('_active');
        },
        // onLeave: (self) => {
        //   self.trigger.classList.add("_hide");
        //   self.trigger.classList.remove("_active");
        // },
        // onEnterBack: (self) => {
        //   self.trigger.classList.add("_active");
        //   self.trigger.classList.remove("_hide");
        // },
        // onLeaveBack: (self) => {
        //   self.trigger.classList.remove("_active");
        // },
      });

      ScrollTrigger.create({
        trigger: '.timeline-horizontally__col--6-1-6 .timeline-horizontally__title',
        containerAnimation: scrollTween,
        start: 'left 95%',
        end: 'right 30%',
        onEnter: (self) => {
          self.trigger.classList.add('_active');
        },
        // onLeave: (self) => {
        //   self.trigger.classList.add("_hide");
        //   self.trigger.classList.remove("_active");
        // },
        // onEnterBack: (self) => {
        //   self.trigger.classList.add("_active");
        //   self.trigger.classList.remove("_hide");
        // },
        // onLeaveBack: (self) => {
        //   self.trigger.classList.remove("_active");
        // },
      });

      ScrollTrigger.create({
        trigger: '.timeline-horizontally__col--6-1-6 .timeline-horizontally__img--1',
        containerAnimation: scrollTween,
        start: 'left 95%',
        end: 'right 30%',
        onEnter: (self) => {
          self.trigger.classList.add('_active');
        },
        // onLeave: (self) => {
        //   self.trigger.classList.add("_hide");
        //   self.trigger.classList.remove("_active");
        // },
        // onEnterBack: (self) => {
        //   self.trigger.classList.add("_active");
        //   self.trigger.classList.remove("_hide");
        // },
        // onLeaveBack: (self) => {
        //   self.trigger.classList.remove("_active");
        // },
      });

      ScrollTrigger.create({
        trigger: '.timeline-horizontally__col--6-1-6 .timeline-horizontally__img--2',
        containerAnimation: scrollTween,
        start: 'left 95%',
        end: 'right 30%',
        onEnter: (self) => {
          self.trigger.classList.add('_active');
        },
        // onLeave: (self) => {
        //   self.trigger.classList.add("_hide");
        //   self.trigger.classList.remove("_active");
        // },
        // onEnterBack: (self) => {
        //   self.trigger.classList.add("_active");
        //   self.trigger.classList.remove("_hide");
        // },
        // onLeaveBack: (self) => {
        //   self.trigger.classList.remove("_active");
        // },
      });

      ScrollTrigger.create({
        trigger: '.timeline-horizontally__col--6-1-6 .timeline-horizontally__text',
        containerAnimation: scrollTween,
        start: 'left 95%',
        end: 'right 30%',
        onEnter: (self) => {
          self.trigger.classList.add('_active');
        },
        // onLeave: (self) => {
        //   self.trigger.classList.add("_hide");
        //   self.trigger.classList.remove("_active");
        // },
        // onEnterBack: (self) => {
        //   self.trigger.classList.add("_active");
        //   self.trigger.classList.remove("_hide");
        // },
        // onLeaveBack: (self) => {
        //   self.trigger.classList.remove("_active");
        // },
      });

      ScrollTrigger.create({
        trigger: '.timeline-horizontally__col--6-1-7 .timeline-horizontally__title',
        containerAnimation: scrollTween,
        start: 'left 95%',
        end: 'right 30%',
        onEnter: (self) => {
          self.trigger.classList.add('_active');
        },
        // onLeave: (self) => {
        //   self.trigger.classList.add("_hide");
        //   self.trigger.classList.remove("_active");
        // },
        // onEnterBack: (self) => {
        //   self.trigger.classList.add("_active");
        //   self.trigger.classList.remove("_hide");
        // },
        // onLeaveBack: (self) => {
        //   self.trigger.classList.remove("_active");
        // },
      });

      ScrollTrigger.create({
        trigger: '.timeline-horizontally__col--6-1-7 .timeline-horizontally__text',
        containerAnimation: scrollTween,
        start: 'left 95%',
        end: 'right 30%',
        onEnter: (self) => {
          self.trigger.classList.add('_active');
        },
        // onLeave: (self) => {
        //   self.trigger.classList.add("_hide");
        //   self.trigger.classList.remove("_active");
        // },
        // onEnterBack: (self) => {
        //   self.trigger.classList.add("_active");
        //   self.trigger.classList.remove("_hide");
        // },
        // onLeaveBack: (self) => {
        //   self.trigger.classList.remove("_active");
        // },
      });

      ScrollTrigger.create({
        trigger: '.timeline-horizontally__col--6-1-8 .timeline-horizontally__note',
        containerAnimation: scrollTween,
        start: 'left 95%',
        end: 'right 30%',
        onEnter: (self) => {
          self.trigger.classList.add('_active');
        },
        // onLeave: (self) => {
        //   self.trigger.classList.add("_hide");
        //   self.trigger.classList.remove("_active");
        // },
        // onEnterBack: (self) => {
        //   self.trigger.classList.add("_active");
        //   self.trigger.classList.remove("_hide");
        // },
        // onLeaveBack: (self) => {
        //   self.trigger.classList.remove("_active");
        // },
      });

      ScrollTrigger.create({
        trigger: '.timeline-horizontally__col--6-1-9 .timeline-horizontally__quote',
        containerAnimation: scrollTween,
        start: 'left 95%',
        end: 'right 30%',
        onEnter: (self) => {
          self.trigger.classList.add('_active');
        },
        // onLeave: (self) => {
        //   self.trigger.classList.add("_hide");
        //   self.trigger.classList.remove("_active");
        // },
        // onEnterBack: (self) => {
        //   self.trigger.classList.add("_active");
        //   self.trigger.classList.remove("_hide");
        // },
        // onLeaveBack: (self) => {
        //   self.trigger.classList.remove("_active");
        // },
      });

      ScrollTrigger.create({
        trigger: '.timeline-horizontally__col--4-1 .timeline-horizontally__month',
        containerAnimation: scrollTween,
        start: 'left 95%',
        end: 'right 30%',
        onEnter: (self) => {
          self.trigger.classList.add('_active');
        },
        // onLeave: (self) => {
        //   self.trigger.classList.add("_hide");
        //   self.trigger.classList.remove("_active");
        // },
        // onEnterBack: (self) => {
        //   self.trigger.classList.add("_active");
        //   self.trigger.classList.remove("_hide");
        // },
        // onLeaveBack: (self) => {
        //   self.trigger.classList.remove("_active");
        // },
      });

      ScrollTrigger.create({
        trigger: '.timeline-horizontally__col--4-2 .timeline-horizontally__text--1',
        containerAnimation: scrollTween,
        start: 'left 95%',
        end: 'right 30%',
        onEnter: (self) => {
          self.trigger.classList.add('_active');
        },
        // onLeave: (self) => {
        //   self.trigger.classList.add("_hide");
        //   self.trigger.classList.remove("_active");
        // },
        // onEnterBack: (self) => {
        //   self.trigger.classList.add("_active");
        //   self.trigger.classList.remove("_hide");
        // },
        // onLeaveBack: (self) => {
        //   self.trigger.classList.remove("_active");
        // },
      });

      ScrollTrigger.create({
        trigger: '.timeline-horizontally__col--4-2 .timeline-horizontally__text--2',
        containerAnimation: scrollTween,
        start: 'left 95%',
        end: 'right 30%',
        onEnter: (self) => {
          self.trigger.classList.add('_active');
        },
        // onLeave: (self) => {
        //   self.trigger.classList.add("_hide");
        //   self.trigger.classList.remove("_active");
        // },
        // onEnterBack: (self) => {
        //   self.trigger.classList.add("_active");
        //   self.trigger.classList.remove("_hide");
        // },
        // onLeaveBack: (self) => {
        //   self.trigger.classList.remove("_active");
        // },
      });

      ScrollTrigger.create({
        trigger: '.timeline-horizontally__col--4-3 .timeline-horizontally__note',
        containerAnimation: scrollTween,
        start: 'left 95%',
        end: 'right 30%',
        onEnter: (self) => {
          self.trigger.classList.add('_active');
        },
        // onLeave: (self) => {
        //   self.trigger.classList.add("_hide");
        //   self.trigger.classList.remove("_active");
        // },
        // onEnterBack: (self) => {
        //   self.trigger.classList.add("_active");
        //   self.trigger.classList.remove("_hide");
        // },
        // onLeaveBack: (self) => {
        //   self.trigger.classList.remove("_active");
        // },
      });

      ScrollTrigger.create({
        trigger: '.timeline-horizontally__col--4-4 .timeline-horizontally__img',
        containerAnimation: scrollTween,
        start: 'left 95%',
        end: 'right 30%',
        onEnter: (self) => {
          self.trigger.classList.add('_active');
          // setCurrentFooter(4);
        },
        // onLeave: (self) => {
        //   self.trigger.classList.add("_hide");
        //   self.trigger.classList.remove("_active");
        // },
        // onEnterBack: (self) => {
        //   self.trigger.classList.add("_active");
        //   self.trigger.classList.remove("_hide");
        // },
        onLeaveBack: (self) => {
          // setCurrentFooter(3);
        },
      });

      ScrollTrigger.create({
        trigger: '.timeline-horizontally__col--9-1-1 .timeline-horizontally__month',
        containerAnimation: scrollTween,
        start: 'left 95%',
        end: 'right 30%',
        onEnter: (self) => {
          self.trigger.classList.add('_active');
        },
        // onLeave: (self) => {
        //   self.trigger.classList.add("_hide");
        //   self.trigger.classList.remove("_active");
        // },
        // onEnterBack: (self) => {
        //   self.trigger.classList.add("_active");
        //   self.trigger.classList.remove("_hide");
        // },
        // onLeaveBack: (self) => {
        //   self.trigger.classList.remove("_active");
        // },
      });

      ScrollTrigger.create({
        trigger: '.timeline-horizontally__col--9-1-2 .timeline-horizontally__text',
        containerAnimation: scrollTween,
        start: 'left 95%',
        end: 'right 30%',
        onEnter: (self) => {
          self.trigger.classList.add('_active');
        },
        // onLeave: (self) => {
        //   self.trigger.classList.add("_hide");
        //   self.trigger.classList.remove("_active");
        // },
        // onEnterBack: (self) => {
        //   self.trigger.classList.add("_active");
        //   self.trigger.classList.remove("_hide");
        // },
        // onLeaveBack: (self) => {
        //   self.trigger.classList.remove("_active");
        // },
      });

      ScrollTrigger.create({
        trigger: '.timeline-horizontally__col--9-1-2 .timeline-horizontally__title',
        containerAnimation: scrollTween,
        start: 'left 95%',
        end: 'right 30%',
        onEnter: (self) => {
          self.trigger.classList.add('_active');
          setCurrentFooter(4);
        },
        // onLeave: (self) => {
        //   self.trigger.classList.add("_hide");
        //   self.trigger.classList.remove("_active");
        // },
        // onEnterBack: (self) => {
        //   self.trigger.classList.add("_active");
        //   self.trigger.classList.remove("_hide");
        // },
        onLeaveBack: (self) => {
          setCurrentFooter(3);
        },
      });

      ScrollTrigger.create({
        trigger: '.timeline-horizontally__col--9-1-2 .timeline-horizontally__text',
        containerAnimation: scrollTween,
        start: 'left 95%',
        end: 'right 30%',
        onEnter: (self) => {
          self.trigger.classList.add('_active');
        },
        // onLeave: (self) => {
        //   self.trigger.classList.add("_hide");
        //   self.trigger.classList.remove("_active");
        // },
        // onEnterBack: (self) => {
        //   self.trigger.classList.add("_active");
        //   self.trigger.classList.remove("_hide");
        // },
        // onLeaveBack: (self) => {
        //   self.trigger.classList.remove("_active");
        // },
      });

      // ScrollTrigger.create({
      //   trigger: '.timeline-horizontally__col--9-1-3 .timeline-horizontally__quote',
      //   containerAnimation: scrollTween,
      //   start: 'left 95%',
      //   end: 'right 30%',
      //   onEnter: (self) => {
      //     self.trigger.classList.add('_active');
      //   },
      //   // onLeave: (self) => {
      //   //   self.trigger.classList.add("_hide");
      //   //   self.trigger.classList.remove("_active");
      //   // },
      //   // onEnterBack: (self) => {
      //   //   self.trigger.classList.add("_active");
      //   //   self.trigger.classList.remove("_hide");
      //   // },
      //   // onLeaveBack: (self) => {
      //   //   self.trigger.classList.remove("_active");
      //   // },
      // });

      ScrollTrigger.create({
        trigger: '.timeline-horizontally__col--9-1-3 .timeline-horizontally__quote',
        containerAnimation: scrollTween,
        start: 'left 95%',
        end: 'right 30%',
        onEnter: (self) => {
          self.trigger.classList.add('_active');
        },
        // onLeave: (self) => {
        //   self.trigger.classList.add("_hide");
        //   self.trigger.classList.remove("_active");
        // },
        // onEnterBack: (self) => {
        //   self.trigger.classList.add("_active");
        //   self.trigger.classList.remove("_hide");
        // },
        // onLeaveBack: (self) => {
        //   self.trigger.classList.remove("_active");
        // },
      });

      ScrollTrigger.create({
        trigger: '.timeline-horizontally__col--9-1-3 .timeline-horizontally__text--1',
        containerAnimation: scrollTween,
        start: 'left 95%',
        end: 'right 30%',
        onEnter: (self) => {
          self.trigger.classList.add('_active');
        },
        // onLeave: (self) => {
        //   self.trigger.classList.add("_hide");
        //   self.trigger.classList.remove("_active");
        // },
        // onEnterBack: (self) => {
        //   self.trigger.classList.add("_active");
        //   self.trigger.classList.remove("_hide");
        // },
        // onLeaveBack: (self) => {
        //   self.trigger.classList.remove("_active");
        // },
      });

      ScrollTrigger.create({
        trigger: '.timeline-horizontally__col--9-1-3 .timeline-horizontally__text--2',
        containerAnimation: scrollTween,
        start: 'left 95%',
        end: 'right 30%',
        onEnter: (self) => {
          self.trigger.classList.add('_active');
          // setCurrentFooter(3);
        },
        // onLeave: (self) => {
        //   self.trigger.classList.add("_hide");
        //   self.trigger.classList.remove("_active");
        // },
        // onEnterBack: (self) => {
        //   self.trigger.classList.add("_active");
        //   self.trigger.classList.remove("_hide");
        // },
        onLeaveBack: (self) => {
          // setCurrentFooter(2);
        },
      });

      ScrollTrigger.create({
        trigger: '.timeline-horizontally__col--2-1 .timeline-horizontally__month',
        containerAnimation: scrollTween,
        start: 'left 95%',
        end: 'right 30%',
        onEnter: (self) => {
          self.trigger.classList.add('_active');
          // setCurrentFooter(5);
        },
        // onLeave: (self) => {
        //   self.trigger.classList.add("_hide");
        //   self.trigger.classList.remove("_active");
        // },
        // onEnterBack: (self) => {
        //   self.trigger.classList.add("_active");
        //   self.trigger.classList.remove("_hide");
        // },
        onLeaveBack: (self) => {
          // setCurrentFooter(4);
        },
      });

      ScrollTrigger.create({
        trigger: '.timeline-horizontally__col--2-2 .timeline-horizontally__title',
        containerAnimation: scrollTween,
        start: 'left 90%',
        end: 'right 30%',
        onEnter: (self) => {
          self.trigger.classList.add('_active');
          setCurrentFooter(5);
        },
        // onLeave: (self) => {
        //   self.trigger.classList.add("_hide");
        //   self.trigger.classList.remove("_active");
        // },
        // onEnterBack: (self) => {
        //   self.trigger.classList.add("_active");
        //   self.trigger.classList.remove("_hide");
        // },
        onLeaveBack: (self) => {
          setCurrentFooter(4);
        },
      });

      ScrollTrigger.create({
        trigger: '.timeline-horizontally__col--2-2 .timeline-horizontally__text',
        containerAnimation: scrollTween,
        start: 'left 95%',
        end: 'right 30%',
        onEnter: (self) => {
          self.trigger.classList.add('_active');
        },
        // onLeave: (self) => {
        //   self.trigger.classList.add("_hide");
        //   self.trigger.classList.remove("_active");
        // },
        // onEnterBack: (self) => {
        //   self.trigger.classList.add("_active");
        //   self.trigger.classList.remove("_hide");
        // },
        // onLeaveBack: (self) => {
        //   self.trigger.classList.remove("_active");
        // },
      });

      ScrollTrigger.create({
        trigger: '.timeline-horizontally__col--2-2 .timeline-horizontally__note',
        containerAnimation: scrollTween,
        start: 'left 95%',
        end: 'right 30%',
        onEnter: (self) => {
          self.trigger.classList.add('_active');
        },
        // onLeave: (self) => {
        //   self.trigger.classList.add("_hide");
        //   self.trigger.classList.remove("_active");
        // },
        // onEnterBack: (self) => {
        //   self.trigger.classList.add("_active");
        //   self.trigger.classList.remove("_hide");
        // },
        // onLeaveBack: (self) => {
        //   self.trigger.classList.remove("_active");
        // },
      });

      ScrollTrigger.create({
        trigger: '.timeline-horizontally__col--2-3 .timeline-horizontally__img',
        containerAnimation: scrollTween,
        start: 'left 95%',
        end: 'right 30%',
        onEnter: (self) => {
          self.trigger.classList.add('_active');
        },
        // onLeave: (self) => {
        //   self.trigger.classList.add("_hide");
        //   self.trigger.classList.remove("_active");
        // },
        // onEnterBack: (self) => {
        //   self.trigger.classList.add("_active");
        //   self.trigger.classList.remove("_hide");
        // },
        // onLeaveBack: (self) => {
        //   self.trigger.classList.remove("_active");
        // },
      });

      ScrollTrigger.create({
        trigger: '.timeline-horizontally__col--2-4 .timeline-horizontally__note',
        containerAnimation: scrollTween,
        start: 'left 95%',
        end: 'right 30%',
        onEnter: (self) => {
          self.trigger.classList.add('_active');
        },
        // onLeave: (self) => {
        //   self.trigger.classList.add("_hide");
        //   self.trigger.classList.remove("_active");
        // },
        // onEnterBack: (self) => {
        //   self.trigger.classList.add("_active");
        //   self.trigger.classList.remove("_hide");
        // },
        // onLeaveBack: (self) => {
        //   self.trigger.classList.remove("_active");
        // },
      });

      ScrollTrigger.create({
        trigger: '.timeline-horizontally__col--2-5 .timeline-horizontally__title',
        containerAnimation: scrollTween,
        start: 'left 95%',
        end: 'right 30%',
        onEnter: (self) => {
          self.trigger.classList.add('_active');
          // setCurrentFooter(4);
        },
        // onLeave: (self) => {
        //   self.trigger.classList.add("_hide");
        //   self.trigger.classList.remove("_active");
        // },
        // onEnterBack: (self) => {
        //   self.trigger.classList.add("_active");
        //   self.trigger.classList.remove("_hide");
        // },
        onLeaveBack: (self) => {
          // setCurrentFooter(3);
        },
      });

      ScrollTrigger.create({
        trigger: '.timeline-horizontally__col--2-6 .timeline-horizontally__text',
        containerAnimation: scrollTween,
        start: 'left 95%',
        end: 'right 30%',
        onEnter: (self) => {
          self.trigger.classList.add('_active');
        },
        // onLeave: (self) => {
        //   self.trigger.classList.add("_hide");
        //   self.trigger.classList.remove("_active");
        // },
        // onEnterBack: (self) => {
        //   self.trigger.classList.add("_active");
        //   self.trigger.classList.remove("_hide");
        // },
        // onLeaveBack: (self) => {
        //   self.trigger.classList.remove("_active");
        // },
      });

      ScrollTrigger.create({
        trigger: '.timeline-horizontally__item--end .timeline-horizontally__title',
        containerAnimation: scrollTween,
        start: 'left 95%',
        end: 'right 30%',
        onEnter: (self) => {
          self.trigger.classList.add('_active');
        },
        // onLeave: (self) => {
        //   self.trigger.classList.add("_hide");
        //   self.trigger.classList.remove("_active");
        // },
        // onEnterBack: (self) => {
        //   self.trigger.classList.add("_active");
        //   self.trigger.classList.remove("_hide");
        // },
        // onLeaveBack: (self) => {
        //   self.trigger.classList.remove("_active");
        // },
      });

      ScrollTrigger.create({
        trigger: '.timeline-horizontally__item--end .timeline-horizontally__subtitle',
        containerAnimation: scrollTween,
        start: 'left 95%',
        end: 'right 30%',
        onEnter: (self) => {
          self.trigger.classList.add('_active');
        },
        // onLeave: (self) => {
        //   self.trigger.classList.add("_hide");
        //   self.trigger.classList.remove("_active");
        // },
        // onEnterBack: (self) => {
        //   self.trigger.classList.add("_active");
        //   self.trigger.classList.remove("_hide");
        // },
        // onLeaveBack: (self) => {
        //   self.trigger.classList.remove("_active");
        // },
      });

      ScrollTrigger.create({
        trigger: '.timeline-horizontally__item--end .timeline-horizontally__text',
        containerAnimation: scrollTween,
        start: 'left 95%',
        end: 'right 30%',
        onEnter: (self) => {
          self.trigger.classList.add('_active');
        },
        // onLeave: (self) => {
        //   self.trigger.classList.add("_hide");
        //   self.trigger.classList.remove("_active");
        // },
        // onEnterBack: (self) => {
        //   self.trigger.classList.add("_active");
        //   self.trigger.classList.remove("_hide");
        // },
        // onLeaveBack: (self) => {
        //   self.trigger.classList.remove("_active");
        // },
      });

      ScrollTrigger.create({
        trigger: '.timeline-horizontally__item--end .timeline-horizontally__btn',
        containerAnimation: scrollTween,
        start: 'left 95%',
        end: 'right 30%',
        onEnter: (self) => {
          self.trigger.classList.add('_active');
        },
        // onLeave: (self) => {
        //   self.trigger.classList.add("_hide");
        //   self.trigger.classList.remove("_active");
        // },
        // onEnterBack: (self) => {
        //   self.trigger.classList.add("_active");
        //   self.trigger.classList.remove("_hide");
        // },
        // onLeaveBack: (self) => {
        //   self.trigger.classList.remove("_active");
        // },
      });


      // let getPosition = getScrollLookup('.years__item', {
      //   start: 'center center',
      //   containerAnimation: scrollTween,
      // });

      // gsap.utils.toArray('.years__item').forEach((el) => {
      //   el.addEventListener('click', (e) => {
      //     e.preventDefault();
      //     gsap.to(window, {
      //       scrollTo: getPosition(el.getAttribute('href')),
      //       overwrite: 'auto',
      //       duration: 1,
      //     });
      //   });
      // });

      // function getScrollLookup(targets, { start, pinnedContainer, containerAnimation }) {
      //   let triggers = gsap.utils.toArray(targets).map((el) => {
      //       // console.log('el: ', el);

      //       ScrollTrigger.create({
      //         trigger: el,
      //         start: start || 'top top',
      //         pinnedContainer: pinnedContainer,
      //         refreshPriority: -10,
      //         containerAnimation: containerAnimation,
      //       });
      //     }),
      //     st = containerAnimation && containerAnimation.scrollTrigger;
      //     console.log('st: ', st);
      //   return (target) => {
      //     let t = gsap.utils.toArray(target)[0],
      //       i = triggers.length;
      //     console.log('t: ', t);
      //     console.log('i: ', i);
      //     while (i-- && triggers[i].trigger !== t) {}
      //     if (i < 0) {
      //       return console.warn('target not found', target);
      //     }
      //     return containerAnimation
      //       ? st.start + (triggers[i].start / containerAnimation.duration()) * (st.end - st.start)
      //       : triggers[i].start;
      //   };
      // }

      const setCurrentFooter = (index) => {
        console.log('index: ', index);
        const footerYears = document.querySelector('.years');
        

        if (footerYears) {
          for (let i = 0; i < 6; i++) {
            footerYears.classList.remove(`years--active-${i}`);
          }

          if (index === 1) return footerYears.classList.add('years--active-1');
          if (index === 2) return footerYears.classList.add('years--active-2');
          if (index === 3) return footerYears.classList.add('years--active-3');
          if (index === 4) return footerYears.classList.add('years--active-4');
          if (index === 5) return footerYears.classList.add('years--active-5');
        }
      };



  
  
    document.querySelectorAll(".years__item").forEach((anchor) => {
      anchor.addEventListener("click", function (e) {
          e.preventDefault();
        setScroll(e);
      });
    });


  } else {

    let tops = [];
    
    document.querySelectorAll('.years .years__item').forEach(function(anchor){

      let id = anchor.getAttribute('href');
      let top = document.querySelector(id).getBoundingClientRect().top + window.scrollY;

      tops.push({
        anchor,
        id,
        top
      })

    })

    window.addEventListener('scroll', function(){
      console.log(tops, window.scrollY);
      let activeItems = tops.filter(item => item.top < window.scrollY);
      if(activeItems.length !== anchors.length){
        setAnchors(activeItems);
      }
    })

    // console.log(tops);
    // anchors, setAnchors

  }


  // setLoad(true);
  setTw(scrollTween);
  },[] );

  useEffect(() => {
    if(anchors && anchors.length > 0){
      document.querySelectorAll('.years .years__item').forEach(item => item.classList.remove('_active'));
      anchors.map(item => {
        item.anchor.classList.add('_active');
      })
    }
  }, [anchors.length])  

  function setScroll(e) {
    console.log('e: ', e);
    // console.log('e: ', e.target.getAttribute("href"));
  

    let num;

    const panelsContainer = document.querySelector(".timeline-horizontally__list");
    console.log("click");
    
    
    let y;
    let targetElem;
    let indent = 0;
    let years;
  
    

    if (e.target) {
      targetElem = document.querySelector(e.target.getAttribute("href"));
      console.log('targetElem1: ', e.target.getAttribute("href"));

      years = e.target.getAttribute("href").replace("#m", "");

      
     
    
    } else {
      targetElem = document.querySelector(`#m${e}`);
      console.log('e: ', e);
      console.log('targetElem2: ', e);
      years= e;

    }
    console.log('scrollTween: ', tw);
    console.log('years: ', years);

    if (years == 2009 || years == 2010) {
      indent = 500;
 
    } 
    console.log('indent: ', indent);
    y = targetElem; 
    let twee = tw ? tw : scrollTween;
    if (targetElem && panelsContainer.isSameNode(targetElem.parentElement)) {
      let totalScroll = twee.scrollTrigger.end - twee.scrollTrigger.start,
        totalMovement = panelsContainer.scrollWidth - window.innerWidth;
      y = Math.round(
        twee.scrollTrigger.start +
          (targetElem.offsetLeft / totalMovement) * totalScroll
      );
    }



      gsap.to(window, {
        scrollTo: {
          y: y - indent,
          autoKill: false
        },
        duration: 1
      });


   
      // switch (e) {
      //   case 2017:
      //     num = 0;
      //     break;
      //   case 2018:
      //     num = 10400;
      //     break;
      //   case 2019:
      //     num = 23400;
      //     break;
      //   case 2020:
      //     num = 31600;
      //     break;
      //   case 2021:
      //     num = 41300;
      //     break;
      //   case 2022:
      //     num = 54400;
      //     break;
      // }
    


  }

  useEffect(() => {

    if (anchor) {
      console.log('ancors: ', anchor);
      if (anchor.years >= 2007 && anchor.years <= 2011) {
        setTimeout(()=>{
          setScroll(anchor.years);
        },200)
       
      } else {
        console.log("enddd");
        setEnd(true);
      }
      
    }

  
  
  },[anchor])

  // return (
  //   <>
  //     {/* <div style={{ width: "100%", height: "300vh", background: "red" }}></div> */}
  //     <TimelineHorizontally progress={progress}/>
  //   </>
  // );

  return <>{children({ progress, setEndOne, show })}</>;
}

export default GsapContainer;
